import { render, staticRenderFns } from "./nutrition-step-two.html?vue&type=template&id=364e1406&scoped=true&"
import script from "./nutrition-step-two.js?vue&type=script&lang=js&"
export * from "./nutrition-step-two.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-two.scss?vue&type=style&index=0&id=364e1406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e1406",
  null
  
)

export default component.exports